// extracted by mini-css-extract-plugin
module.exports = {"introOption":"_2HMXe-","introOptionTitle":"_3r8yiC","introOptionText":"_1QZVGe","introOptionSave":"_1iNd1z","introOptionLabel":"_2ZqTTg","introOptionCheckbox":"Atr7vY"};